import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Activity, AlertTriangle, Droplets, Shield } from "lucide-react";
import React from "react";

interface NetworkHealthSummaryProps {
  data: any;
}

export const NetworkHealthSummary: React.FC<NetworkHealthSummaryProps> = ({
  data,
}) => {
  const cards = [
    {
      title: "Network Condition Index",
      displayValue: `${data?.overview?.networkHealthIndex?.value ?? "NA"}`,
      tooltip:
        "A single, comprehensive score representing the overall health of the network, combining physical condition, operational performance, and compliance.",
      icon: <Activity className="h-8 w-8 text-blue-600" />,
    },
    {
      title: "Non Revenue Water",
      count: data?.overview?.nonRevenueWater?.value ?? "NA",
      icon: <Droplets className="h-8 w-8 text-green-500" />,
      tooltip:
        "Percentage of total water produced that is lost before reaching consumers, due to leaks, theft, or meter inaccuracies.",
    },
    {
      title: "Network Availability",
      displayValue: `${data?.overview?.networkAvailability?.value ?? "NA"}`,
      tooltip:
        "The percentage of time the network has been operational and available to provide service as scheduled.",
      icon: <Shield className="h-8 w-8 text-purple-600" />,
    },
    {
      title: "Out of Service Assets",
      displayValue: `${data?.overview?.outOfServiceAssets?.value ?? "NA"}`,
      tooltip:
        "The number of assets within this network that are currently in a non-operational state due to failure or maintenance.",
      icon: <AlertTriangle className="h-8 w-8 text-orange-600" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, idx) => (
        <div key={idx}>
          <QuickStatsCard {...card} />
        </div>
      ))}
    </div>
  );
};
